<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";

interface TRANS {
  locale: string;
  icon: string;
  language: string;
  langCode: string;
}

const { t, locale } = useI18n();

const changeLocale = (value: string) => {
  locale.value = value;
  localStorage.setItem("locale", value);
  window.location.reload();
};
</script>

<template>
  <Menu as="div" class="relative ml-3 mr-2">
    <div>
      <MenuButton
        class="flex rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
      >
        <span class="sr-only">Open Menu</span>
        <img
          v-if="locale === 'en'"
          src="@/assets/img/en.svg"
          alt="EN"
          width="24"
          height="24"
          class="mr-2 cursor-pointer"
        />
        <img
          v-if="locale === 'es'"
          src="@/assets/img/es.svg"
          alt="ES"
          width="24"
          height="24"
          class="mr-2 cursor-pointer"
        />
      </MenuButton>
    </div>
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems
        class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      >
        <MenuItem v-slot="{ active }">
          <a
            @click="changeLocale('en')"
            class="cursor-pointer"
            :class="[
              locale === 'en' ? 'bg-gray-100' : '',
              'flex px-4 py-2 text-sm text-gray-700',
            ]"
          >
            <img
              src="@/assets/img/en.svg"
              alt="EN"
              width="24"
              height="24"
              class="mr-2 cursor-pointer"
            />
            <span>English</span>
          </a>
        </MenuItem>
        <MenuItem v-slot="{ active }">
          <a
            @click="changeLocale('es')"
            class="cursor-pointer"
            :class="[
              locale === 'es' ? 'bg-gray-100' : '',
              'flex px-4 py-2 text-sm text-gray-700',
            ]"
          >
            <img
              src="@/assets/img/es.svg"
              alt="ES"
              width="24"
              height="24"
              class="mr-2 cursor-pointer"
            />
            <span>Español</span>
          </a>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>
